import { Mail, User } from "lucide-react";
import { Link } from "react-router-dom";
import { authorProfile } from "@/data/author";

const FooterConnect = () => {
  return (
    <div className="flex flex-col items-center sm:items-start">
      <h3 className="text-xl font-semibold mb-6 text-red-400">Connect</h3>
      
      {/* Social Media Links */}
      <div className="mb-6">
        <h4 className="text-lg font-medium mb-4 text-gray-200">Follow Us</h4>
        <div className="flex space-x-4">
          <a 
            href="https://www.facebook.com/satyam.chauhan.940436/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="group"
            aria-label="Facebook"
          >
            <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center group-hover:bg-blue-700 transition-colors transform group-hover:scale-110 duration-200">
              <img 
                src="/Media/Website Images/Main Facebook logo.png" 
                alt="Facebook" 
                className="h-6 w-6"
              />
            </div>
          </a>
          <a 
            href="https://www.instagram.com/satyam__chavan/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="group"
            aria-label="Instagram"
          >
            <div className="w-10 h-10 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center group-hover:from-purple-600 group-hover:to-pink-600 transition-all transform group-hover:scale-110 duration-200">
              <img 
                src="/Media/Website Images/Instagram Logo.png" 
                alt="Instagram" 
                className="h-6 w-6"
              />
            </div>
          </a>
          <a 
            href="https://in.pinterest.com/MyLearnMedX/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="group"
            aria-label="Pinterest"
          >
            <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center group-hover:bg-gray-100 transition-colors transform group-hover:scale-110 duration-200">
              <img 
                src="/Media/Website Images/Main Pinterest Logo.png" 
                alt="Pinterest" 
                className="h-6 w-6"
              />
            </div>
          </a>
          <a 
            href="https://github.com/satyam4056" 
            target="_blank" 
            rel="noopener noreferrer"
            className="group"
            aria-label="GitHub"
          >
            <div className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center group-hover:bg-gray-700 transition-colors transform group-hover:scale-110 duration-200">
              <img 
                src="/Media/Website Images/Main Github Logo.png" 
                alt="GitHub" 
                className="h-6 w-6"
              />
            </div>
          </a>
          <a 
            href="https://www.youtube.com/@LearnMedX" 
            target="_blank" 
            rel="noopener noreferrer"
            className="group"
            aria-label="YouTube"
          >
            <div className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center group-hover:bg-red-700 transition-colors transform group-hover:scale-110 duration-200">
              <img 
                src="/Media/Website Images/Main Youtube Logo.png" 
                alt="YouTube" 
                className="h-6 w-6"
              />
            </div>
          </a>
        </div>
      </div>
      
      <div className="mt-6">
        <h4 className="text-lg font-medium mb-4 text-gray-200">Author</h4>
        <Link to={`/author/${authorProfile.slug}`} className="flex items-center text-gray-300 hover:text-white transition-colors group">
          <User className="h-5 w-5 mr-3 text-red-500" />
          <span className="text-lg group-hover:translate-x-1 transform duration-200">{authorProfile.name}</span>
        </Link>
      </div>
    </div>
  );
};

export default FooterConnect;
